import { render, staticRenderFns } from "./resource-filter-sidebar.vue?vue&type=template&id=a7dac6f4&"
import script from "./resource-filter-sidebar.vue?vue&type=script&lang=js&"
export * from "./resource-filter-sidebar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports